import axios from "axios";
import { Loading } from "element-ui";
import qs from "qs";
import config from "../common/config";
import { store } from "../store/store";
let isFormHeader = false;
let isAgainRequst = false;
let ifMultipart = false; //上传文件添加Content-Type="multipart/form-data"
let loading; //定义loading变量
let needLoadingRequestCount = 0;
let accessToken = sessionStorage.getItem("accessToken");
let showLogingOutConfirm = true;
//重试队列，每一项将是一个待执行的函数形式
let retryRequests = [];
let http = axios.create({
  // baseURL: `${config.baseUrl}`,
  baseURL: config.baseUrl,
  // baseURL: `${process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_BASEURL}`,
  withCredentials: false,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    Authorization: accessToken
  },
  transformRequest: [
    function(data) {
      if (isAgainRequst) {
        return data;
      }

      if (isFormHeader) {
        return qs.stringify(data);
      } else {
        if (ifMultipart) {
          return data;
        } else {
          return JSON.stringify(data);
        }
      }
    }
  ]
});


function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中",
    background: "rgba(0, 0, 0, 0.5)"
  });
}

function endLoading() {
  if (loading) loading.close();
}

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

http.interceptors.request.use(
  config => {
    if (isFormHeader) {
      config.headers["Content-Type"] =
        "application/x-www-form-urlencoded;charset=utf-8";
      config.headers["Authorization"] = sessionStorage.getItem("accessToken");
    } else if (ifMultipart) {
      config.headers["Content-Type"] = "multipart/form-data";
      // config.headers["type"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      config.headers["Authorization"] = sessionStorage.getItem("accessToken");
    } else {
      config.headers["Authorization"] = sessionStorage.getItem("accessToken");
    }
    if (config.method == "get"||config.method == "delete") {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  error => {
    window.console.log(error);
  }
);

http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    let errCode = "";
    if (error.response) {
      errCode = error.response.data.code;
    }
  }
);

function apiAxios(method, url, params, isLoading) {
  return new Promise((resolve, reject) => {
    if (isLoading) {
      showFullScreenLoading();
    }
    http({
      method: method,
      url,
      data: method === "POST" || method === "PUT" ? params : null,
      params: method === "GET" || method === "DELETE" ? params : null,
      paramsSerializer: function(params) {
        // 在get请求里带数组，默认下会变成state[]=1&state[]=2,这样不行，需要的格式是state=1&state=2
        // 所以在这里将get请求参数都重新变一次
        return qs.stringify(params, {arrayFormat: 'repeat'});
      }
    })
      .then(function(res) {
        if (isLoading) {
          tryHideFullScreenLoading();
        }
        showLogingOutConfirm = true;
        if (res.status === 200) {
          //http 响应状态是200为正常         //  && res.data.status 这个不一定有
          if (res.data.code == "20030000" ) {
            // const config = error.response.config;
            if( sessionStorage.getItem("refreshTokenFlag")==1)
            {
              sessionStorage.setItem("refreshTokenFlag",0)
              confirm("由于您长时间没有登录，请重新登录");
              store.get("goLoginRouter")();
            }else{
              store.get("goLoginRouter")();
            }

            return;
          } else {
            resolve(res.data);
          }
          resolve(res.data);
        } else if (res.status === 200 && !res.data.status) {
          resolve(res.data);
        } else if (res.status == 404) {
          reject("系统异常");
        }else if (res.status == 413) {
          reject("单个文件大小最大支持50M");
        } else {
          reject("系统异常");
          // reject(res.message);
        }
      })
      .catch(function(err) {
        if (isLoading) {
          tryHideFullScreenLoading();
        }
        //请求超时异常处理
        if (!err.response) {
          reject("系统异常");
        }

        if (err.isAxiosError && err.response.status == 404) {
          return;
        }
        let errCode = "";
        if (err.response) {
          errCode = err.response.data.code;
        }
        if (
          errCode == "30131" ||
          errCode == "30132" ||
          errCode == "30133" ||
          errCode == "30134" ||
          errCode == "30135" ||
          errCode == "30136" ||
          errCode == "30137" ||
          errCode == "30138" ||
          errCode == "30139"
        ) {
          if (showLogingOutConfirm) {
            showLogingOutConfirm = false;
            let s = confirm(err.response.data.msg);
            if (s) {
              store.get("goLoginRouter")();
            }
          }
        }
        // 服务连接失败err.message为"Network Error", 连接超时（就是超过设定的timeout的时间）err.message为timeout of 3000ms exceeded
        if (err.message === "Request failed with status code 401") {
          console.log("err 401");
        } else {
          // reject(err.message || err);
          reject("系统异常");
        }
      });
  });
}
export default {
  get: function(url, params, isFormData, isLoading = false) {
    isFormHeader = true;
    isAgainRequst = false;
    return apiAxios("GET", url, params, isLoading);
  },
  post: function(
    url,
    params,
    isFormData,
    isLoading = false,
    ifMultipartFlag = false
  ) {
    isFormHeader = isFormData;
    ifMultipart = ifMultipartFlag;
    isAgainRequst = false;
    return apiAxios("POST", url, params, isLoading);
  },
  put: function(url, params, isFormData) {
    isFormHeader = isFormData;
    isAgainRequst = false;
    ifMultipart =false;
    return apiAxios("PUT", url, params);
  },
  delete: function(url, params) {
    isAgainRequst = false;
    ifMultipart =false;
    return apiAxios("DELETE", url, params);
  }
};
